import { createFileRoute } from "@tanstack/react-router";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { PublicoHero, Publico, Process, FinalCTA } from "@/components/landing/Sections";

export const Route = createFileRoute("/public")({
  head: () => ({
    meta: [
      { title: "Instituciones y ferias · SUSIEDAD" },
      {
        name: "description",
        content:
          "Producción para ayuntamientos, ferias, fiestas populares y actos institucionales. Sonido, iluminación, cabina, montaje y desmontaje. Málaga y toda España.",
      },
    ],
  }),
  component: () => (
    <div className="min-h-screen bg-background text-foreground">
      {/* La página abre con la plaza a sangre: la cabecera flota encima en hueso. */}
      <SiteHeader overlay />
      <main>
        <PublicoHero />
        <Publico />
        <Process />
        <FinalCTA />
      </main>
      <SiteFooter />
    </div>
  ),
});
